import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkBox"];

  checkAll() {
    this.checkBoxTargets.forEach((checkBox) => (checkBox.checked = true));
  }
}
